import { isString } from '@sa/utils';
import { useState } from 'react';

import useBoolean from './use-boolean';

/**
 * Loading
 *
 * @deprecated
 * @param initValue Init value
 */
export function useLoadingLegacy(initValue = false) {
  const { bool: loading, setFalse: endLoading, setTrue: startLoading } = useBoolean(initValue);

  return {
    endLoading,
    loading,
    startLoading
  };
}

export default function useLoading<T extends Record<string, boolean>, R = (keyof T)[]>(data: T) {
  const [loading, setLoading] = useState(data);
  return {
    endLoading: (keys: keyof T | R) => {
      const _loading: Record<string, false> = {};
      let _keys: any[] = [];
      if (isString(keys)) {
        _keys = [keys];
      }
      for (const key of _keys) {
        _loading[key] = false;
      }
      setLoading({
        ...loading,
        ..._loading
      });
    },
    loading,
    startLoading: (keys: keyof T | R) => {
      const _loading: Record<string, true> = {};
      let _keys: any[] = [];
      if (isString(keys)) {
        _keys = [keys];
      }
      for (const key of _keys) {
        _loading[key] = true;
      }
      setLoading({
        ...loading,
        ..._loading
      });
    }
  };
}
